import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const GoogleDriveIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 465 465">
        <defs>
            <path
                d="M279.279602,0 L141.859939,0 L0,247.248134 L67.0618942,366.293532 L354.077646,366.293532 L421.13954,247.248134 L279.279602,0 Z M136.023494,247.248134 L210.56977,118.587531 L285.116046,247.248134 L136.023494,247.248134 Z"
                id="path-1"
            />
            <linearGradient
                x1="25.3104364%"
                y1="50.1992308%"
                x2="100.670317%"
                y2="97.5886538%"
                id="linearGradient-3"
            >
                <stop stopColor="#1A237E" stopOpacity="0.2" offset="0%" />
                <stop stopColor="#1A237E" stopOpacity="0.02" offset="100%" />
            </linearGradient>
            <path
                d="M279.279602,0 L141.859939,0 L0,247.248134 L67.0618942,366.293532 L354.077646,366.293532 L421.13954,247.248134 L279.279602,0 Z M136.023494,247.248134 L210.56977,118.587531 L285.116046,247.248134 L136.023494,247.248134 Z"
                id="path-4"
            />
            <path
                d="M279.279602,0 L141.859939,0 L0,247.248134 L67.0618942,366.293532 L354.077646,366.293532 L421.13954,247.248134 L279.279602,0 Z M136.023494,247.248134 L210.56977,118.587531 L285.116046,247.248134 L136.023494,247.248134 Z"
                id="path-6"
            />
            <path
                d="M279.279602,0 L141.859939,0 L0,247.248134 L67.0618942,366.293532 L354.077646,366.293532 L421.13954,247.248134 L279.279602,0 Z M136.023494,247.248134 L210.56977,118.587531 L285.116046,247.248134 L136.023494,247.248134 Z"
                id="path-8"
            />
            <polygon
                id="path-10"
                points="0.0429150347 119.045398 287.058667 119.045398 354.120561 0 69.0045147 0"
            />
            <path
                d="M279.279602,0 L141.859939,0 L0,247.248134 L67.0618942,366.293532 L354.077646,366.293532 L421.13954,247.248134 L279.279602,0 Z M136.023494,247.248134 L210.56977,118.587531 L285.116046,247.248134 L136.023494,247.248134 Z"
                id="path-12"
            />
            <polygon
                id="path-14"
                points="141.859939 0 0 247.248134 67.0618942 366.293532 210.56977 118.587531"
            />
            <radialGradient
                cx="33.8956522%"
                cy="1.010375%"
                fx="33.8956522%"
                fy="1.010375%"
                r="114.507098%"
                gradientTransform="translate(0.338957,0.010104),scale(0.869768,1.000000),translate(-0.338957,-0.010104)"
                id="radialGradient-16"
            >
                <stop stopColor="#FFFFFF" stopOpacity="0.1" offset="0%" />
                <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
            </radialGradient>
        </defs>
        <g
            id="Drive-Lockup---with-gray-Google"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Group-3">
                <g
                    id="logo_drive_96in128dp"
                    transform="translate(11.564472, 2.891791)"
                >
                    <g id="Group" transform="translate(9.155207, 36.629353)">
                        <g id="Clipped">
                            <g>
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1" />
                                </mask>
                                <g id="SVGID_1_" />
                                <g id="Group" mask="url(#mask-2)">
                                    <g transform="translate(67.018979, 247.248134)">
                                        <polygon
                                            id="Shape"
                                            fill="#4285F4"
                                            fillRule="nonzero"
                                            points="0.0429150347 0 0.0429150347 119.045398 287.058667 119.045398 354.120561 0"
                                        />
                                        <polygon
                                            id="Shape"
                                            fill="url(#linearGradient-3)"
                                            fillRule="nonzero"
                                            points="69.0045147 0 137.989002 119.045398 0.0429150347 119.045398"
                                        />
                                        <g
                                            id="Group"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <polygon
                                                id="Shape"
                                                fillOpacity="0.2"
                                                fill="#FFFFFF"
                                                fillRule="nonzero"
                                                points="67.6770097 2.28933458 350.20671 2.28933458 350.20671 2.28933458 354.120561 0 69.0045147 0 69.0045147 0"
                                            />
                                            <polygon
                                                id="Shape"
                                                fillOpacity="0.2"
                                                fill="#1A237E"
                                                fillRule="nonzero"
                                                points="350.20671 2.28933458 285.731162 116.756063 1.37042011 116.756063 0.0429150347 119.045398 287.058667 119.045398 354.120561 0"
                                            />
                                            <polygon
                                                id="Shape"
                                                fillOpacity="0.05"
                                                fill="#1A237E"
                                                fillRule="nonzero"
                                                points="70.3320198 2.28933458 69.0045147 0 0.0429150347 119.045398 2.67503716 119.045398"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g>
                                <mask id="mask-5" fill="white">
                                    <use xlinkHref="#path-4" />
                                </mask>
                                <g id="SVGID_1_" />
                                <g
                                    id="Group"
                                    mask="url(#mask-5)"
                                    fillRule="nonzero"
                                >
                                    <polygon
                                        id="Shape"
                                        fill="#0F9D58"
                                        points="141.859939 0 0 247.248134 67.0618942 366.293532 228.857297 87.0176073"
                                    />
                                    <g id="Shape">
                                        <polygon
                                            fillOpacity="0.1"
                                            fill="#263238"
                                            points="141.859939 0 143.11878 6.753537 207.91476 118.587531 67.0847822 361.669076 2.63212213 247.248134 0 247.248134 67.0618942 366.293532 210.56977 118.587531"
                                        />
                                        <polygon
                                            fillOpacity="0.2"
                                            fill="#FFFFFF"
                                            points="2.63212213 247.248134 143.187444 2.28933458 141.859939 0 141.859939 0 0 247.248134"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g>
                                <mask id="mask-7" fill="white">
                                    <use xlinkHref="#path-6" />
                                </mask>
                                <g id="SVGID_1_" />
                                <g id="Group" mask="url(#mask-7)">
                                    <g transform="translate(141.762664, 0.000000)">
                                        <polygon
                                            id="Shape"
                                            fill="#FFCD40"
                                            fillRule="nonzero"
                                            points="137.516937 0 0.0972740786 0 143.353382 247.248134 279.376876 247.248134"
                                        />
                                        <g
                                            id="Group"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <polygon
                                                id="Shape"
                                                fillOpacity="0.2"
                                                fill="#FFFFFF"
                                                fillRule="nonzero"
                                                points="137.516937 0 0.0972740786 0 4.05690128 2.28933458 136.189432 2.28933458 276.744754 247.248134 279.376876 247.248134"
                                            />
                                            <polygon
                                                id="Shape"
                                                fillOpacity="0.1"
                                                fill="#BF360C"
                                                fillRule="nonzero"
                                                points="144.657999 244.9588 4.05690128 2.28933458 4.05690128 2.28933458 0.0972740786 0 143.353382 247.248134"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g>
                                <mask id="mask-13" fill="white">
                                    <use xlinkHref="#path-12" />
                                </mask>
                                <g id="SVGID_1_" />
                                <g mask="url(#mask-13)">
                                    <mask id="mask-15" fill="white">
                                        <use xlinkHref="#path-14" />
                                    </mask>
                                    <g id="SVGID_6_" />
                                    <g id="Group" mask="url(#mask-15)">
                                        <g transform="translate(114.297042, -18.314677)">
                                            <polygon
                                                id="Shape"
                                                fill="#FFCD40"
                                                fillRule="nonzero"
                                                points="164.982559 18.3146766 27.5628963 18.3146766 170.819004 265.562811 306.842498 265.562811"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <path
                            d="M279.279602,0 L141.859939,0 L0,247.248134 L67.0618942,366.293532 L354.077646,366.293532 L421.13954,247.248134 L279.279602,0 Z M136.023494,247.248134 L210.56977,118.587531 L285.116046,247.248134 L136.023494,247.248134 Z"
                            id="Shape"
                            fill="url(#radialGradient-16)"
                            fillRule="nonzero"
                        />
                    </g>
                    <rect
                        id="Rectangle-path"
                        x="0"
                        y="0"
                        width="439.449955"
                        height="439.552239"
                    />
                </g>
                <rect id="Rectangle" x="0" y="0" width="465" height="465" />
            </g>
        </g>
    </SvgIcon>
);

export default GoogleDriveIcon;
